<template>
  <div id="throwing-screen" v-if="show">
    <div class="img-ct" v-if="tools">
      <div class="projection-cover-close" @click="close($event)"></div>
      <div class="projection-cover-rotate" @click="rotate"></div>
      <div class="projection-cover-big" @click="enlarge"></div>
      <div class="projection-cover-small" @click="narrow"></div>
      <img
        id="img-item"
        :src="img_url"
        alt=""
        ref="imageBoxItem"
        @mousedown="down_copy($event)"
        @mousemove="move_copy($event)"
        @mouseup="end_copy($event)"
        @touchstart.prevent="down_copy($event)"
        @touchmove.prevent="move_copy($event)"
        @touchend.prevent="end_copy($event)"
        :style="{
          transform: 'rotate(' + rotateItem + 'deg) scale(' + multiple + ')',
          width: width + 'px',
          height: height + 'px',
        }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "throwing-screen",
  data() {
    return {
      //是否显示投屏
      show: false,
      //是否显示投屏结果
      tools: false,
      //上传地址
      img_doc_uploader_url: "",
      //图片地址
      img_url: "",
      //图片宽度
      width: "",
      //图片高度
      height: "",
      //图片cdn id
      file_cdn_id: "",
      //图片旋转角度
      rotateItem: 0,
      key: 1,
      //初始化倍数
      multiple: 1,
      //增大缩小阶梯倍数
      multiple_scale: 0.2,
      scroll_x: 0,
      scroll_y: 0,
      // init_width:0,
      // init_height:0,
      count: 0,
      //拖动
      body_width: 0,
      body_height: 0,
      flag: false,
      cur: {
        x: 0,
        y: 0,
      },
      nx: 0,
      ny: 0,
      dx: 0,
      x: 0,
      y: 0,
      div2: null,
      move_obj: {
        //移动的偏移量
        left: "0.5rem",
        top: "0.5rem",
        off_left: 0,
        off_top: 0,
      },
      pointer_obj: {
        //移动的位置
        //轨迹点
        start_x: "",
        start_y: "",
        end_x: "",
        end_y: "",
      },
      start_time: "",
      end_time: "",
    };
  },
  props: ["data", "item"],
  watch: {
    data(val) {
      console.log(val);
      this.tools = false;
      this.multiple = 1;
      this.img_url = "";
      this.width = "";
      this.height = "";
      (this.file_cdn_id = ""), this.jude_show(val);
      // console.log("33333333333333333333333333333");
    },
    item(val) {
      // console.log(val);
      // console.log("22222222222222222222222222222222222222");
      this.jude_serve(val);
    },
  },
  computed: {},
  methods: {
    down_copy(event) {
      console.log("123123");
      event.preventDefault();
      this.flag = true;
      this.div2 = document.getElementById("img-item");
      this.body_width = document.body.clientWidth - 30;
      this.body_height = document.body.clientHeight - 30;
      // this.start_time =  Date.parse( new Date());
      //判断是否是移动端
      if (event.touches) {
        // console.log(event.getPressure())
        this.pointer_obj.start_x = Math.ceil(event.touches[0].clientX);
        this.pointer_obj.start_y = Math.ceil(event.touches[0].clientY);
      } else {
        this.pointer_obj.start_x = Math.ceil(event.pageX);
        this.pointer_obj.start_y = Math.ceil(event.pageY);
      }
      this.move_obj.off_left = this.$refs.imageBoxItem.offsetLeft;
      this.move_obj.off_top = this.$refs.imageBoxItem.offsetTop;
    },
    move_copy(event) {
      event.preventDefault();
      // return ;
      if (this.flag) {
        if (event.touches) {
          this.pointer_obj.end_x = Math.ceil(event.touches[0].clientX);
          this.pointer_obj.end_y = Math.ceil(event.touches[0].clientY);
        } else {
          this.pointer_obj.end_x = Math.ceil(event.pageX);
          this.pointer_obj.end_y = Math.ceil(event.pageY);
        }
        this.x =
          this.pointer_obj.end_x -
          this.pointer_obj.start_x +
          this.move_obj.off_left;
        this.y =
          this.pointer_obj.end_y -
          this.pointer_obj.start_y +
          this.move_obj.off_top;
        this.div2.style.left = this.x + "px";
        this.div2.style.top = this.y + "px";
        if (
          this.x < -370 ||
          this.y < -50 ||
          this.x > this.body_width ||
          this.y > this.body_height
        ) {
          console.log("已超出边界");
          return;
        }
      }
    },
    end_copy(event) {
      event.preventDefault();
      this.scroll_x = (this.x + this.div2.clientWidth / 2) / this.body_width;
      this.scroll_y = (this.y + this.div2.clientHeight / 2) / this.body_height;
      // this.init_width = this.div2.clientWidth;
      // this.init_height = this.div2.clientHeight;
      console.log(this.x / this.body_width);
      console.log(this.y / this.body_height);
      console.log((this.x + this.div2.clientWidth / 2) / this.body_width);
      console.log((this.y + this.div2.clientHeight / 2) / this.body_height);
      this.publicSend();
      this.flag = false;
    },
    //初始化图片
    initImg() {
      this.multiple = 1;
      this.scroll_x = 0;
      this.scroll_y = 0;
      this.x = 0;
      this.y = 0;
      this.div2 = document.getElementById("img-item");
      this.div2.style.left = "auto";
      this.div2.style.top = "auto";
    },
    //放大缩小公用发送函数
    publicSend() {
      let data = {};
      data.file_cdn_url = this.img_url;
      data.file_cdn_id = this.file_cdn_id;
      data.rotate = this.rotateItem;
      data.ws_multiple = this.multiple;
      data.scroll_x = this.scroll_x;
      data.scroll_y = this.scroll_y;
      // data.init_width = this.init_width;
      // data.init_height = this.init_height;
      data.count = 1;
      this.$emit("watchThrow", data);
    },
    //放大图片
    enlarge() {
      this.multiple = this.multiple + this.multiple_scale;
      this.publicSend();
    },
    //缩小图片
    narrow() {
      if (this.multiple <= this.multiple_scale * 2) {
        return;
      }
      this.multiple = this.multiple - this.multiple_scale;
      this.publicSend();
    },
    //监听推送事件
    jude_serve(val) {
      console.log(val);
      if (val.event_name == "event_projection_screen") {
        this.show = true;
        this.tools = true;
        this.img_url = val.data.url;
        this.$nextTick(function () {});
        this.div2 = document.getElementById("img-item");
        if (this.rotateItem != val.data.pic_rotate) {
          this.div2.style.left = "auto";
          this.div2.style.top = "auto";
        }
        this.rotateItem = val.data.pic_rotate;
        this.file_cdn_id = val.data.fiel_cdn_id;
        console.log(val.data.ws_multiple);
        if (val.data.ws_multiple) {
          this.multiple = val.data.ws_multiple;
        }
        if (val.data.scroll_x && val.data.scroll_y) {
          this.body_width = document.body.clientWidth - 30;
          this.body_height = document.body.clientHeight - 30;
          // let different_width = this.div2.clientWidth / val.data.init_width;
          // let different_height = this.div2.clientHeight / val.data.init_height;
          document.getElementById("img-item").style.left =
            (val.data.scroll_x - this.div2.clientWidth / 2 / this.body_width) *
              this.body_width +
            "px";
          document.getElementById("img-item").style.top =
            (val.data.scroll_y -
              this.div2.clientHeight / 2 / this.body_height) *
              this.body_height +
            "px";
        }
        this.$loading.hide();
        this.init();
      } else if (val.event_name == "event_projection_screen_close") {
        this.show = false;
        this.tools = false;
        this.img_url = "";
        this.width = "";
        this.height = "";
        this.count = 0;
        this.$loading.hide();
      } else {
        console.log("暂无该类型");
      }
    },
    //监听点击投屏
    jude_show(val) {
      this.show = val;
      const _this = this;
      let input_dom = $("#file_head");
      input_dom.val("");
      $(document).off("change", "#file_head");
      $(document).on("change", "#file_head", function (e) {
        _this.$loading.show("投屏中...");
        var file = e.target.files[0];
        if (file.type.indexOf("image") == -1) {
          _this.$message("文件格式不支持，请上传其他格式文件");
          return;
        }
        console.log(e);
        console.log(file);

        _this.uploadFile_copy("6", file, _this.test_function, "", "投屏中...");

        // _this.reduce_img(file,function(res){
        //     _this.uploadFile_copy('6',_this.dataURLtoBlob(res),_this.test_function,'','投屏中...');
        //     _this.rotateItem = 0;
        //     setTimeout(()=>{
        //         _this.$loading.hide();
        //     },0)
        //     //
        // });
      });
    },
    //旋转图片
    rotate() {
      this.initImg();
      this.rotateItem = this.rotateItem + 90;
      this.rotateItem = this.rotateItem == 360 ? 0 : this.rotateItem;
      let data = {};
      data.file_cdn_url = this.img_url;
      data.file_cdn_id = this.file_cdn_id;
      data.rotate = this.rotateItem;
      data.ws_multiple = this.multiple;
      data.scroll_x = this.scroll_x;
      data.scroll_y = this.scroll_y;
      data.count = 1;
      this.$emit("watchThrow", data);
      this.init();
    },
    //关闭投屏
    close(event) {
      if (event) {
        event.stopPropagation
          ? event.stopPropagation()
          : (event.cancelBubble = true);
      }
      this.tools = false;
      this.img_url = "";
      let data = {
        count: 0,
      };
      this.$emit("watchThrow", data);
    },
    //上传回调
    test_function(data) {
      console.log(data);
      this.img_url = data.file_cdn_url;
      this.file_cdn_id = data.file_cdn_id;
      data.rotate = this.rotateItem;
      data.count = this.key;
      this.$emit("watchThrow", data);
      this.init();
      this.key++;
      this.$flydata.flydataTrack(70);
    },
    //初始化调用
    init() {
      var img = new Image();
      img.src = this.img_url;
      const _this = this;
      // _this.$loading.show();
      img.onload = function () {
        _this.$loading.hide();
        _this.imgInitStyle(
          img.width,
          img.height,
          document.body.clientWidth,
          document.body.clientHeight,
          1
        );
      };
    },
    //imgStyle初始化
    imgInitStyle(W, H, W_CT, H_CT, type) {
      const videoH = H;
      const videoW = W;
      const video_wrap_height = H_CT;
      const video_wrap_width = W_CT;
      let width_times = video_wrap_width / videoW;
      let height_times = video_wrap_height / videoH;
      let count;
      if (this.rotateItem == 90 || this.rotateItem == 270) {
        width_times = video_wrap_width / videoH;
        height_times = video_wrap_height / videoW;
      }
      if (width_times < 1 || height_times < 1) {
        if (width_times > height_times) {
          count = height_times;
        } else {
          count = width_times;
        }
      } else {
        if (width_times > height_times) {
          count = height_times;
        } else {
          count = width_times;
        }
        count = 1;
      }
      this.width = videoW * count;
      this.height = videoH * count;
      this.tools = true;
    },
  },
  created() {},
  components: {},
  mounted() {
    if (this.item) {
      this.jude_serve(this.item);
    } else {
      this.jude_show(this.data);
    }
    // if (window.location.protocol === "https:") {
    //     this.img_doc_uploader_url = "https://up.qbox.me";
    // } else {
    //     this.img_doc_uploader_url = "http://up.qiniu.com";
    // }
    //华东
    if (window.location.protocol === "https:") {
      this.img_doc_uploader_url = "https://upload.qiniup.com";
    } else {
      this.img_doc_uploader_url = "http://upload.qiniup.com";
    }
  },
};
</script>

<style lang="scss" scoped>
#throwing-screen {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  input {
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
  .img-ct {
    display: -webkit-flex;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    // overflow: auto;
    background: rgba(0, 0, 0, 0.4);
    z-index: 99999999999999;
    img {
      max-width: 100%;
      position: absolute;
    }
    /*投屏*/
    // .interact-screen-projection {
    //     background: url('../../assets/images/icon_screen_projection.png') no-repeat center 2px;
    // }
    // .interact-screen-projection input {
    //     position: absolute;
    //     left: 0;
    //     top: 0;
    //     width: 100%;
    //     height: 100%;
    //     cursor: pointer;
    // }
    // .interact-screen-projection::after {
    //     content: "";
    //     position: absolute;
    //     width: 1px;
    //     height: 40px;
    //     background: #D8D8D8;
    //     right: 0px;
    //     top: 12px;
    // }
    // .projection-cover {
    //     display: flex;
    //     display: -webkit-flex;
    //     align-items: center;
    //     justify-content: center;
    //     position: absolute;
    //     width: 100%;
    //     height: 100%;
    //     z-index: 5001;
    //     overflow: hidden;
    //     z-index:99999999;
    //     background: rgba(0, 0, 0, 0.40);
    // }
    // .projection-cover img {
    //     opacity: 1;
    // }
    .projection-cover-close {
      position: fixed;
      right: 0.5rem;
      top: 0.2rem;
      width: 0.72rem;
      height: 0.72rem;
      cursor: pointer;
      background: url("../../assets/images/inter_throw_close.svg") no-repeat
        center center;
      background-size: 100% 100%;
      z-index: 6000;
      opacity: 1;
    }
    // .projection-cover-available {
    //     position: absolute;
    //     right: 1.25rem;
    //     bottom: 0.83rem;
    //     width: 3rem;
    //     height: 3rem;
    //     cursor: pointer;
    //     background: url('../../assets/images/icon_no_projection_screen.png') no-repeat center center;
    //     background-size: 100% 100%;
    //     z-index: 6000;
    //     opacity: 1;
    // }
    // .projection-cover-available.active {
    //     background: url('../../assets/images/icon_can_projection_screen.png') no-repeat center center;
    //     background-size: 100% 100%;
    // }
    .projection-cover-rotate {
      position: fixed;
      right: 1.5rem;
      top: 0.2rem;
      width: 0.72rem;
      height: 0.72rem;
      cursor: pointer;
      background: url("../../assets/images/inter_throw_rotate.svg") no-repeat
        center center;
      background-size: 100% 100%;
      z-index: 6000;
      opacity: 1;
    }
    .projection-cover-small {
      position: fixed;
      right: 3.5rem;
      top: 0.2rem;
      width: 0.72rem;
      height: 0.72rem;
      cursor: pointer;
      background: url("../../assets/images/inter_throw_minify.svg") no-repeat
        center center;
      background-size: 100% 100%;
      z-index: 6000;
      opacity: 1;
    }
    .projection-cover-big {
      position: fixed;
      right: 2.5rem;
      top: 0.2rem;
      width: 0.72rem;
      height: 0.72rem;
      cursor: pointer;
      background: url("../../assets/images/inter_throw_mmagnify.svg") no-repeat
        center center;
      background-size: 100% 100%;
      z-index: 6000;
      opacity: 1;
    }
  }
}
</style>
